import { Component, Input, OnInit } from "@angular/core";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { OperacionAbmEnum } from "app/enums/operacion-abm.enum";
import { FieldConfig } from "app/genericForm/field.interface";


@Component({
  selector: "app-modal-abm",
  template: `

  <div class="modal-header text-white">
  <h5>{{ getTitle() }}</h5>
  <button type="button" mat-button color="basic" (click)="close()"> <i
                  class="nb-close"></i></button>
</div>
<div class="modal-body">
    <dynamic-form *ngIf="formFields" [fields]="formFields"
      (submit)="submit($event)" (valueChanges)="valueChanges($event)">
    </dynamic-form>
  </div>
`,
  styleUrls: ["./modal-abm.component.scss"]
})
export class ModalAbmComponent implements OnInit {
  @Input() public formFields: FieldConfig[];
  @Input() public modalRef: NgbModalRef;
  @Input() public operacion: OperacionAbmEnum;
  @Input() valueChangeCallbackModal: (args: any) => void;
  constructor() {
  }
 

  ngOnInit() {
    if (this.formFields.filter(f => f.type === "submit").length === 0) {
      this.formFields.push(
        {
          type: "espacioEnBlanco",
          claseGrillaBootstrap: "col-10"
        },
        {
          type: "submit",
          claseGrillaBootstrap: "col-auto float-right",
          label: this.operacion === OperacionAbmEnum.Crear ? "Agregar" : "Modificar"
        }
      );
    }
  }

  submit(formulario: any) {
    this.modalRef.close(formulario);
  }

  valueChanges( $event: any) {
    if(this.valueChangeCallbackModal){
      this.valueChangeCallbackModal($event);
    }
  }

  close() {
    this.modalRef.close();
  }

  getTitle() {
    return this.operacion === OperacionAbmEnum.Crear ? "Agregar" : "Modificar";
  }
}
